/** The characters a word can read as the erhua suffix: 儿 and its traditional form 兒. */
export const ERHUA_CHARACTERS: ReadonlySet<string> = new Set(["儿", "兒"]);
